import styled from '@emotion/styled'

export const ImagesGalleryImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;

  ${({ theme }) => theme.breakpoints.down('md')} {
    position: static;
    object-fit: revert;
  }
`
